import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { userAtom } from '@/store/store'
import { listMyRequestsFromDB } from '@/api/requests'

export default function useMyRequests() {
  const user = useAtomValue(userAtom)

  return useQuery({
    queryKey: ['requests', 'my', user.userId],
    queryFn: ({ signal }) => listMyRequestsFromDB(signal),
    enabled: !!user.userId,
  })
}
